import React from 'react';
import { NavLink } from 'react-router-dom';

var img1 = require('./../../images/background/bg-4.png');
var img2 = require('./../../images/background/bg-site.png');

class OurValue3 extends React.Component {
    
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-gray bg-no-repeat bg-bottom-right mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        <div className="section-content ">
                            <div className="row">
                                <div className="col-md-7 col-sm-6  m-b30">
                                    <div className="brochur bg-dark p-a20">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="p-a30 bg-primary bg-bottom-right" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                                    <div className="text-black">
                                                        <h4 className="mt-tilte m-t0"> Resilience Through Fire-Safe Solutions</h4>
                                                        <p>We believe every problem deserves a precise, lasting solution. From identifying risks to installing intelligent fire safety systems, our expert team is ready to propose, design, and execute the right fit — tailored for your space and industry.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="text-white p-r15">
                                                    <h4 className="mt-tilte">Let's help you!</h4>
                                                    <p>Have questions about fire safety systems, maintenance, or compliance?
Our experts are ready to guide you with smart, reliable solutions that protect lives and property.</p>
                                                    <button className="site-button btn-effect" onClick={(e) => {
                                                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                                                    e.target.blur(); // Remove focus to reset style
                                                    }}>Contact Us</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-6 m-b30">
                                    <div className="our-exp">
                                        <div className="mt-box">
                                            <h3 className="m-t0"><span className="font-weight-100"> We have</span><span className="text-primary"> 5 years</span> experience in Fire Fitting Solutions</h3>
                                        </div>
                                        <span className="progressText text-black"><b>Field-Tested Solutions</b></span>
                                        <div className="progress mt-probar-1  m-b30 m-t10">
                                        </div>
                                        <span className="progressText text-black"><b>Continuous Improvement</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10"></div>
                                        <span className="progressText text-black"><b>Multi-System Integration Expertise</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10"></div>

                                        <span className="progressText text-black"><b>Long-Term Maintenance & AMC Strength</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10"></div>
                                        <span className="progressText text-black"><b>Safety-First Culture</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10"></div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurValue3;